// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"index_avatarContainer__e3weh","iconBtn":"index_iconBtn__r0LT2"};